'use strict';
'use es6';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ajax = require('./utils/Ajax');

var _Ajax2 = _interopRequireDefault(_Ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PostListings = function () {
  function PostListings() {
    _classCallCheck(this, PostListings);
  }

  _createClass(PostListings, [{
    key: 'populateListingFeed',
    value: function populateListingFeed(options) {
      var postListing = document.querySelector('.hs-hash-' + options.id);

      var listing_url = options.listing_url;

      if (window.document.URL) {
        listing_url += '&currentUrl=' + window.encodeURIComponent(window.document.URL);
      }

      if (window.document.referrer) {
        listing_url += '&referrer=' + window.encodeURIComponent(window.document.referrer);
      }

      _Ajax2.default.get(listing_url, function (data) {
        if (postListing.children.length) {
          return;
        }

        data.forEach(function (row) {
          var showFeaturedImage = options.include_featured_image && row.featuredImage;

          var imageHtml = showFeaturedImage ? '\n              <img src="' + row.featuredImage + '" alt="' + row.featuredImageAltText + '">\n            ' : '';

          var html = '\n              <li class="hs-postlisting-item">\n                ' + imageHtml + '\n                <a href="' + row.url + '">' + row.label + '</a>\n              </li>\n            ';
          postListing.insertAdjacentHTML('beforeend', html);
        });
      });

      if (typeof hsPostListingComplete === 'function') {
        window.hsPostListingComplete(postListing);
      }
    }
  }]);

  return PostListings;
}();

window.hsPostListings = new PostListings();
window.hsPopulateListingFeed = window.hsPostListings.populateListingFeed;


//////////////////
// WEBPACK FOOTER
// ./js/post_listing_asset.js
// module id = 2
// module chunks = 2